import type { BalanceUpdatePayload } from '@/lib/providers/WalletSocketProvider';

// ── Wallet balance updates ──

/** A share position's update carries its cost or open price; a currency balance has neither. */
export function isPositionBalanceUpdate({ aop, c }: Pick<BalanceUpdatePayload, 'aop' | 'c'>) {
  return (c !== null && c > 0) || (aop !== null && aop > 0);
}
